const popupExitBtn = document.querySelector('.zumba-popup__exit');
const continuePopupBtn = document.querySelector('.continue-btn');
const zumbaPopup = document.querySelector('.zumba-popup');
const backdrop = document.querySelector('.zumba-popup__backdrop');

const isUserHasMetaHeadset = localStorage.getItem('user-has0meta-headset');

if (!isUserHasMetaHeadset && zumbaPopup) {
  zumbaPopup.classList.remove('no_display');
}

if (popupExitBtn) {
  popupExitBtn.addEventListener('click', (e) => {
    e.preventDefault();

    zumbaPopup.remove();
  });
}

if (continuePopupBtn) {
  continuePopupBtn.addEventListener('click', (e) => {
    e.preventDefault();

    localStorage.setItem('user-has0meta-headset', true);

    zumbaPopup.remove();
  });
}

if (backdrop) {
  backdrop.addEventListener('click', (e) => {
    e.preventDefault();

    zumbaPopup.remove();
  });
}
